<div class="indication-buttons" data-testid="indication-selector" [class.indication-buttons--no-outer-margin]="omitIndicationRowMargin">
	<rx-intuitive-indication-button
		*ngFor="let indicationId of indicationIds; trackBy: indicationIdTrackBy"
		[indication]="indicationId"
		[isActive]="selectedIndicationIds.includes(indicationId)"
		[disabled]="isIndicationDisabled(indicationId)"
		[hideIcon]="hideIcon"
		[asLabel]="asLabel"
		(clicked)="onIndicationClicked(indicationId)"
	>
	</rx-intuitive-indication-button>
	<ng-content></ng-content>
</div>
